import React, {useState} from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import {usePage} from '@inertiajs/react';
import {LoginProps} from '@Pages/Auth/Login/LoginType';
import LogoLogin from "@Pages/Auth/Login/Components/LogoLogin";
import LinksToApp from "@Pages/Auth/Login/Components/LinksToApp";
import LoginForm from "@Pages/Auth/Login/Components/LoginForm";
import {ThemeButton} from "@Components/Form/ThemeButton";
import Language from "@Components/Language";
import {Divider} from "primereact/divider";
import GuestLayout from "@Pages/Auth/GuestLayout";

const reCaptchaSiteKey = import.meta.env.VITE_GOOGLE_RECAPTCHA_SITE_KEY;

function Login() {
  const recaptchaRef = React.useRef<any>(undefined);
  const {settings} = usePage().props as LoginProps;
  const {branding, primaryColor, sso} = settings;

  const reCaptchaSiteKey = import.meta.env.VITE_GOOGLE_RECAPTCHA_SITE_KEY;
  const isUseReCaptcha = Boolean(reCaptchaSiteKey && reCaptchaSiteKey !== 'null');

  const handleRecaptchaExecution = async () => {
    const token = await (recaptchaRef?.current as any)?.execute();
    if (!token) {
      return {success: false, message: 'Please complete the reCAPTCHA'};
    }

    return {success: true, token};
  };

  const isRepsol = branding === "REPSOL";
  const isAlinta = branding === "ALINTA";

  const ssoLoginSection = (
    <>
      <LogoLogin branding={branding}/>
      <LinksToApp/>
      {!isRepsol && (
        <p className="text-center">Single Sign On (SSO)</p>
      )}
      <ThemeButton
        type="button"
        data-dusk="sso-button"
        className="text-white-alpha-90 text-center flex justify-content-center text-lg w-full h-3rem"
        style={{background: primaryColor}}
        onClick={() => window.location.href = route('auth.single-sign-on')}
      >
        {!isRepsol ? (
          Language.get(`SSO Login`)
        ) : (
          Language.get(`Login with ${branding} PingID`)
        )}
      </ThemeButton>
      {!isRepsol && (
        <>
          <Divider align="center" className=" my-4 ">
            <span>Or</span>
          </Divider>
          <div className="mt-4">
            <LoginForm handleRecaptchaExecution={handleRecaptchaExecution} isUseReCaptcha={isUseReCaptcha}/>
          </div>
        </>
      )}
    </>
  );

  const fallbackLoginSection = (
    <div className="input-panel flex flex-column px-3">
      <LogoLogin branding={branding}/>
      <LoginForm handleRecaptchaExecution={handleRecaptchaExecution} isUseReCaptcha={isUseReCaptcha}/>
      <div className="mt-4">
        <LinksToApp/>
      </div>
    </div>
  );


  return (
    <GuestLayout branding={branding}>
      <div></div>
      <div className="align-self-center mt-auto mb-auto">
        {isUseReCaptcha && (
          <ReCAPTCHA ref={recaptchaRef} size="invisible" sitekey={reCaptchaSiteKey}/>
        )}
        {isAlinta ? (
          <div className="flex justify-content-center align-items-center h-screen bg-white">
            <div className="w-full text-center w-30rem px-4" style={{ paddingBottom: '15rem' }}>{ssoLoginSection}</div>
          </div>
        ): (
        <div className="login-pages-panel card flex flex-column">
          {sso ? <div className="pb-6">{ssoLoginSection}</div> : fallbackLoginSection}
        </div>
       )}
      </div>
    </GuestLayout>
  );
}

export default Login;
